<template>
  <SubscriptionInformationComponent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SubscriptionInformationComponent from "@/components/Subscriptions/SubscriptionInformation.vue";

const componentName = "SubscriptionInformationRoute";

export default defineComponent({
  name: componentName,
  components: { SubscriptionInformationComponent },
});
</script>
